// src/pages/FeesBalances.js
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import api from "../../api/api";

const FeesBalances = () => {
  const token = localStorage.getItem("access");
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    const fetchPayments = async () => {
      if (!token) return;
      try {
        const res = await api.get("/api/users/payments/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPayments(res.data);
      } catch (err) {
        setError("Error fetching payments.");
      }
    };
    fetchPayments();
  }, [token]);

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Fee & Balance Summary
      </Typography>

      {payments.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "100%", mx: "auto", overflowX: "auto" }}
        >
          <Table size="small">
            <TableHead sx={{ bgcolor: "#FFEB3B" }}>
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Payment Details
                </TableCell>
              </TableRow>
              <TableRow>
                {["Semester", "Class", "T/Fee", "A/Paid", "Balance", "Date"].map((h) => (
                  <TableCell
                    key={h}
                    sx={{ bgcolor: "#0D1B2A", color: "#fff" }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {payments
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((p) => (
                  <TableRow key={p.id}>
                    <TableCell>{p.semester}</TableCell>
                    <TableCell>{p.student_class_name}</TableCell>
                    <TableCell>${p.total_fee}</TableCell>
                    <TableCell>${p.amount_paid}</TableCell>
                    <TableCell
                      sx={{
                        color: p.balance_fee > 0 ? "red" : "green",
                      }}
                    >
                      ${p.balance_fee}
                    </TableCell>
                    <TableCell>
                      {new Date(p.date).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={payments.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <Box
          sx={{
            bgcolor: "red",
            color: "#fff",
            p: 2,
            borderRadius: 2,
            textAlign: "center",
            mt: 4,
          }}
        >
          <MoneyOffIcon sx={{ fontSize: 50, mb: 1 }} />
          <Typography>No fee has been paid by you!</Typography>
        </Box>
      )}

      {error && (
        <Typography color="error" mt={2}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default FeesBalances;
